"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var DoctorList_1 = require("../components/DoctorList/DoctorList");
var targetNode = document.querySelector('.doctor-list-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(DoctorList_1.default, null), targetNode);
}
